import { useNavigate } from 'react-router-dom';
import { Rocket, ArrowLeft, X } from 'lucide-react';
import { useOnboardingProgress } from '@/components/hooks/useOnboardingProgress';

interface Props {
  id_empresa: string;
}

export default function OnboardingFloatingBar({ id_empresa }: Props) {
  const navigate = useNavigate();
  const { visible, completados, total, porcentaje, setDismissed } =
    useOnboardingProgress(id_empresa);

  if (!visible) return null;

  return (
  <div
    className="fixed left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-lg
      bottom-[calc(4.5rem+env(safe-area-inset-bottom))] lg:bottom-4"
  >
    <div className="bg-[#103254] dark:bg-[#0a1a16] text-white rounded-xl shadow-2xl shadow-[#103254]/40 dark:shadow-black/60 px-4 py-3 flex items-center gap-3">
        <div className="shrink-0 w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center">
          <Rocket className="w-4 h-4 text-white" />
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-white leading-tight">
            Configuración {completados}/{total} completada
          </p>
          <div className="mt-1 h-1.5 bg-white/20 rounded-full overflow-hidden">
            <div
              className="h-full bg-white rounded-full transition-all duration-500"
              style={{ width: `${porcentaje}%` }}
            />
          </div>
        </div>

        <button
          onClick={() => navigate('/panel-empresa')}
          className="shrink-0 flex items-center gap-1.5 bg-white text-[#103254] text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-blue-50 transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Volver
        </button>

        <button
          onClick={() => setDismissed(true)}
          className="shrink-0 text-white/60 hover:text-white transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}